import type { SidebarMode } from "../types";

/**
 * Resolves the effective sidebar mode given the editor's choice and the available data.
 *
 * The editor's mode is a hint; empty data is treated as a runtime accident. If the chosen
 * mode would render an empty sidebar (e.g. "standings-only" when there are no standings),
 * we fall back to "none" so the article pyramid takes the full width instead.
 */
export function resolveEffectiveSidebarMode(input: {
    mode: SidebarMode;
    standingsCount: number;
    highlightedMatchesCount: number;
}): SidebarMode {
    const { mode, standingsCount, highlightedMatchesCount } = input;

    if (mode === "none") return "none";
    if (mode === "standings-only") return standingsCount > 0 ? "standings-only" : "none";
    if (mode === "matches-only") return highlightedMatchesCount > 0 ? "matches-only" : "none";

    // mode === "standings-and-matches"
    if (standingsCount === 0 && highlightedMatchesCount === 0) return "none";
    return "standings-and-matches";
}
